export default {
  items: [
    {
      name: "Inicio",
      url: "/dashboard",
      icon: "icon-grid",
    },
    {
      name: "Pruebas",
      url: "/tests",
      icon: "icon-puzzle",
    },
    {
      name: "Tarjetones",
      url: "/admin-tarjetones",
      icon: "icon-list",
    },
    {
      name: "Metas",
      url: "/goals-management",
      icon: "icon-list",
    },
    // Estudiantes, Maestros, Usuarios and Archivados used to be four separate
    // buttons. They are tabs inside this one section now — see
    // views/Personas/tabs.js. DefaultLayout rewrites this url to the first tab
    // the signed-in role is actually allowed to open.
    {
      name: "Usuarios",
      url: "/users",
      icon: "icon-people",
    },
    {
      name: "Notificaciones",
      url: "/notifications",
      icon: "icon-doc",
    },
  ],
};
